<template>
  <div>
    <BaseButton
      text="Buy Now"
      variant="secondary"
      class="w-100"
      @click="purchaseItemClicked"/>
    <p class="small-text text-pewter mb-0 mt-3 text-center">
      <strong class="me-1">
        This style is with you!
      </strong>
    </p>
    <p class="small-text text-pewter mb-0 text-center">
      Want to keep it forever? Purchase it at our members&#8209;only discount for <strong>${{ itemToPurchase.item.priceClient }}</strong>.
    </p>
  </div>
</template>

<script setup>
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import { useCaseStore } from '@/stores/case.js'
import { useFlyouts } from '@/composables/flyouts.js'

const props = defineProps({
  itemToPurchase: {
    type: Object,
    required: true
  }
})

const { openMyCaseFlyout } = useFlyouts()
const { setMyCaseFlyoutContext } = useCaseStore()

function purchaseItemClicked () {
  setMyCaseFlyoutContext({
    itemToPurchase: props.itemToPurchase
  })
  openMyCaseFlyout('purchase-item')
}
</script>
